import classNames from "components/ui/classNames";

/* eslint-disable react/no-array-index-key */
interface KeyValueTooltipProps {
  x: string;
  keyValues: {
    key: string;
    value: string;
    color?: string;
  }[];
}

export default function KeyValueTooltip({ x, keyValues }: KeyValueTooltipProps) {
  return (
    <div className="z-10 flex flex-col space-y-3 p-2 text-xs">
      <span
        className={classNames(
          "inline-flex justify-center rounded-lg bg-slate-50 px-2 py-1 font-mono text-xs font-bold text-slate-600",
          "dark:bg-slate-900 dark:text-slate-300",
        )}
      >
        {x}
      </span>

      <div className="space-y-1">
        <table>
          <tbody>
            {keyValues.map(({ key, value, color }) => {
              return (
                <tr key={key}>
                  <td className="max-w-36 truncate">
                    <strong
                      className={classNames("font-mono font-bold tracking-wide text-slate-800", "dark:text-slate-100")}
                      style={{
                        color,
                      }}
                    >
                      {key}
                    </strong>
                  </td>
                  <td className="pl-2">
                    <span className={classNames("font-mono text-slate-800", "dark:text-slate-300")}>{value}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
